export default "__VITE_ASSET__CWoj3TLb__"